import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["printable"];

  print() {
    const printableContent = this.printableTarget.innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printableContent;
    window.print();
    document.body.innerHTML = originalContent;
  }
}
